module.exports = __webpack_public_path__ + "202408221624/img/5.ce1d77d2.png";